import { ReactNode } from 'react'
import styled from '@emotion/styled'
import { SpaceProps, space } from 'styled-system'
import { SIDE_PADDING } from '../Layout/Layout'
import Button from '../Button'

interface BottomBarProps extends SpaceProps {
  /**
   * Takes a string to output a class. Related to emotion - It lets another component style it
   */
  className?: string

  children?: ReactNode
}

export const BottomBar = styled.div<BottomBarProps>(
  ({ theme }) => ({
    position: 'sticky',
    bottom: 0,
    marginTop: 'auto',
    zIndex: theme.zIndex.bottombar,
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'space-between',
    padding: theme.space[4],
    paddingTop: theme.space[3],
    paddingBottom: theme.space[3],
    borderTop: theme.border,
    letterSpacing: theme.letterSpacings[1],
    background: theme.colors.white,
    boxShadow: theme.shadows.primary.top[0],
    [theme.mediaQueries.widget]: {
      borderRight: theme.border,
      borderLeft: theme.border
    }
  }),
  space
)

/**
 * BottomBar is a simple wrapper to display the content on the bottom of the page.
 */
export default BottomBar

/**
 * Used inside <BottomBar padding={0}> to format content with greater control:
 * - Sets max width so content is centered
 * - Allows for content outsite of this container to be flush with the edge
 */
export const BottomBarContainer = styled.div<SpaceProps>(
  ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.space[4],
    paddingTop: theme.space[3],
    paddingBottom: theme.space[3],
    ...theme.mixins.centeredContainer(theme.currentMaxWidth, SIDE_PADDING)
  }),
  space
)

/**
 * A button to use inside <BottomBar> or <BottomBarContainer> that will be
 * centred with a max width.
 */
export const BottomBarButton = styled(Button)(({ theme }) => ({
  ...theme.mixins.centeredContainer('sm')
}))
